<style lang="css" scoped>
.vif_box {
    background-color: rgba(0, 0, 0, 0.7);
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}

.modal-container {
    width: 800px;
    margin: 40px auto 0;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.form-label > .form-control {
    margin-top: 0.5em;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>

<template>
    <div name="modal" v-show="value">
        <div class="modal-mask" @click="cancel">
            <div class="modal-container" @click.stop>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :search="search"
                    :single-select=true
                    item-key="id"
                    sort-by="id"
                    class="elevation-1"
                    show-select
                    return-object
                    @dblclick:row="on_dbl_click"
                    v-model="selected_items"
                >
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>Select IPoE profile</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn @click="refresh" variant="light">Refresh</v-btn>
                        </v-toolbar>
                        <v-toolbar flat>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-toolbar>
                    </template>
                    <template v-slot:no-data>
                    </template>
                </v-data-table>
            
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="select">Select</v-btn>
            </div>
        </div>
    </div>
</template>
  
<script>

import { VListItemGroup } from 'vuetify/lib';
import api_client from '../services/api.js';

export default {
    name: 'ipoe_profile_box',
    data: () => ({
        selected_items: [],
        search: '',
        items: [],
        headers: [
            { text: 'Profile ID', value: 'id', align: 'start' },
            { text: 'Name', value: 'name' },
        ],
    }),

    created() {
      this.initialize()
    },

    props: {
        value: {
            required: true
        }
    },
    methods: {
        calc_fields() {
            this.items.forEach(item => {                
            });
        },

        initialize() {
            api_client.run_get_query('/ipoe/profiles')
            .then(response => {
                this.items = response.data;
                calc_fields();
            })
            .catch(error => {
                console.log(error);
            })
        },

        on_dbl_click(event, data) {
		    this.$emit("selected", data.item.id);
        },

        select() {
            if (typeof this.selected_items[0] != "undefined") {
                this.$emit("selected", this.selected_items[0].id);
            }
        },

        cancel() {
            this.$emit("canceled");
        },

        refresh() {
            this.initialize();
        },
    }
};
</script>
